module.exports = __webpack_public_path__ + "static/media/search.095be950.svg";